export interface HeroSlide {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  image: string;
  link: string;
  tag: string;
}

export const heroSlides: HeroSlide[] = [
  {
    id: "h1",
    title: "星际彼岸",
    subtitle: "年度太空史诗 · 口碑热映中",
    description: "人类远航舰队穿越虫洞后与母星失联，一段关于归途与信念的星际旅程就此展开。",
    image: "https://readdy.ai/api/search-image?query=Epic%20cinematic%20space%20scene%2C%20a%20lone%20spaceship%20silhouette%20gliding%20past%20a%20colossal%20ringed%20planet%20with%20swirling%20golden%20nebula%20clouds%2C%20deep%20navy%20space%20with%20warm%20amber%20highlights%2C%20dramatic%20volumetric%20lighting%2C%20ultra%20wide%20composition%2C%20high%20detail%20digital%20painting%2C%20majestic%20awe%20atmosphere&width=1920&height=800&seq=bbtv-hero-h1&orientation=landscape",
    link: "/detail/1001",
    tag: "电影",
  },
  {
    id: "h2",
    title: "雾都迷案",
    subtitle: "年度刑侦口碑剧 · 热播中",
    description: "迷雾笼罩的旧城里，一桩尘封多年的旧案被重新翻开，牵出盘根错节的人情与真相。",
    image: "https://readdy.ai/api/search-image?query=Cinematic%20noir%20city%20scene%20at%20night%2C%20a%20misty%20old%20town%20street%20with%20glowing%20street%20lamps%20and%20a%20lone%20detective%20silhouette%2C%20deep%20navy%20fog%20with%20muted%20warm%20amber%20light%2C%20moody%20suspenseful%20atmosphere%2C%20ultra%20wide%20composition%2C%20high%20detail%20digital%20painting&width=1920&height=800&seq=bbtv-hero-h2&orientation=landscape",
    link: "/detail/2001",
    tag: "电视剧",
  },
  {
    id: "h3",
    title: "大地脉动",
    subtitle: "年度最佳纪录片 · 震撼上映",
    description: "四年拍摄，跨越高原、森林与荒漠，记录这片土地上生命与自然的永恒律动。",
    image: "https://readdy.ai/api/search-image?query=Epic%20sweeping%20nature%20documentary%20scene%2C%20a%20vast%20mountain%20valley%20with%20a%20migrating%20herd%20silhouetted%20against%20golden%20sunlight%20and%20dramatic%20clouds%2C%20deep%20navy%20sky%20with%20rich%20amber%20glow%2C%20ultra%20wide%20composition%2C%20high%20detail%20cinematic%20landscape%20photography%2C%20majestic%20reverent%20mood&width=1920&height=800&seq=bbtv-hero-h3&orientation=landscape",
    link: "/detail/4001",
    tag: "纪录片",
  },
  {
    id: "h4",
    title: "快乐星球旅行团",
    subtitle: "治愈系旅行综艺 · 口碑收官",
    description: "六位嘉宾结伴出发，用最朴素的方式丈量世界，也丈量彼此。",
    image: "https://readdy.ai/api/search-image?query=Uplifting%20travel%20variety%20scene%2C%20a%20group%20of%20travelers%20with%20backpacks%20silhouetted%20on%20a%20mountain%20ridge%20at%20vivid%20sunrise%2C%20deep%20navy%20sky%20with%20warm%20orange%20sunrise%20glow%2C%20energetic%20joyful%20atmosphere%2C%20ultra%20wide%20composition%2C%20stylized%20colorful%20illustration&width=1920&height=800&seq=bbtv-hero-h4&orientation=landscape",
    link: "/detail/3001",
    tag: "综艺",
  },
];